import { combineReducers } from 'redux'

import * as h2Api from '../../h2Api'
import { WIP_RESULTS } from '../../actions/assessments/workImportanceProfiler'

export default combineReducers({
  results: h2Api.restReducer(WIP_RESULTS)
})
